import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function Module5Page() {
  return (
    <div className="min-h-screen bg-[var(--bg-raised)]">
      <header className="bg-[var(--slate-dim)] border-b border-[var(--slate)]">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <Link to="/elevation/workbook/oqf" className="text-[var(--text-sec)] hover:text-[var(--text-pri)] text-sm mb-4 inline-block">
            ← Back to OQF Home
          </Link>
          <h1 className="text-3xl font-bold text-[var(--text-pri)]">
            Module 5: Maintain an Open Questions Register
          </h1>
          <p className="text-[var(--text-sec)] mt-2">
            Objective: By the end of this module, you will be able to populate a shared <strong>OQ Register</strong> to track learning, ownership, and accountability.
          </p>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6 mb-8">
          <h2 className="text-xl font-semibold text-[var(--text-pri)] mb-4">
            🛠️ Concept: The Register as Your "Operating System"
          </h2>
          <p className="text-[var(--text-sec)] mb-4">
            A question that isn't written down <em>will be forgotten</em>. The OQF Register is the shared, visible heartbeat of your team's inquiry. It's the tool that makes the framework tactical, accountable, and persistent.
          </p>
        </div>

        <div className="bg-[var(--bg-raised)] border border-[var(--rule)] p-6 mb-8">
          <h2 className="text-xl font-semibold text-[var(--text-pri)] mb-4">
            Core Register Columns
          </h2>
          <ol className="list-decimal list-inside space-y-2 text-[var(--text-sec)]">
            <li><strong>Open Question:</strong> The OQF-ready question.</li>
            <li><strong>Type / Category:</strong> (e.g., Strategic, Operational, Product)</li>
            <li><strong>Owner:</strong> The <em>single person</em> accountable for driving this question to resolution.</li>
            <li><strong>Current Beliefs/Theories:</strong> What do we <em>think</em> is true right now?</li>
            <li><strong>Evidence Quality:</strong> (Anecdote, Directional, Strong, Verified)</li>
            <li><strong>Source(s) of Truth:</strong> Who or what can give us the answer? (e.g., Customers, Data, Experts)</li>
            <li><strong>Next Step:</strong> The SDE to learn more.</li>
            <li><strong>Status:</strong> (e.g., Unknown, Investigating, Confirmed)</li>
            <li><strong>Confidence:</strong> (Low / Medium / High)</li>
            <li><strong>Impact Tag:</strong> (e.g., Decision, Risk, Opportunity)</li>
            <li><strong>Review Date:</strong> The date this will be reviewed again (to prevent staleness).</li>
            <li><strong>Last Verified:</strong> When was this last updated?</li>
            <li><strong>Dependencies:</strong> What other questions does this block/unblock?</li>
            <li><strong>Notes / Artifacts:</strong> Link to the evidence.</li>
          </ol>
        </div>

        <div className="flex gap-4">
          <Link to="/elevation/workbook/oqf/module-4" className="px-4 py-2 border border-[var(--rule)] text-[var(--text-sec)] hover:bg-[var(--surface)]">
            ← Previous Module
          </Link>
          <Link to="/elevation/workbook/oqf/module-6" className="px-4 py-2 bg-[var(--slate)] text-white hover:bg-[var(--slate)] flex items-center gap-2">
            Next: Module 6
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}






